import {createRouter, createWebHistory} from 'vue-router';
import {getEmail} from '@zettant/awsUtils';
import {isAppReady} from '@/inits';
import defaultValues from '@projectRoot/defaultValues';
import routes from '@projectRoot/router';
// const routes = (await import('@projectRoot/router')).default.routes;

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const router = createRouter({
  routes,
  // Viteの環境変数でimport.meta.env.BASE_URL = vite.config.tsのbase
  history: createWebHistory(import.meta.env.BASE_URL),
});

let entryPath = '';

router.beforeEach((to, from, next) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const requiresAuth = to.matched.some((record) => !!record.meta.requiresAuth);
  if (to.name === 'login') {
    next();
  }
  else if (to.name === 'init') {
    if (isAppReady() || defaultValues.noInitSplash) {
      next('/');
    } else {
      next();
    }
  }
  else {
    if (requiresAuth) {
      router['referrer'] = from;
      if (getEmail()) {  // idTokenからemailを取得するので、ログインしている時しか値が入っていない
        if (isAppReady() || defaultValues.noInitSplash) {
          if (entryPath !== '') {
            const path = entryPath;
            entryPath = '';
            next({path});
          } else {
            next();
          }
        } else {
          if (to.path !== '/') entryPath = to.path as string;
          next({name: 'init'});
        }
      }
      else {
        if (to.path !== '/') entryPath = to.path as string;
        next({name: 'login'});
      }
    }
    else {
      if (['forgot_password', 'verify_code', 'reset_password'].includes(to.name as string)) {
        next();
      } else if (isAppReady() || defaultValues.noInitSplash) {
        next();
      } else {
        next({name: 'init'});
      }
    }
  }
});

export default router;
